"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Other = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Other, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Other);

  function Other() {
    (0, _classCallCheck2["default"])(this, Other);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Other, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M17.6257106,5.97452739 L18.3495041,5.26343202 C18.7385475,4.88121393 19.3621042,4.88121393 19.7511476,5.26343202 L19.7574327,5.26960678 C20.1411056,5.64654866 20.1465623,6.26314885 19.7696204,6.64682184 C19.7655939,6.65092029 19.7615311,6.65498303 19.7574327,6.65900958 L19.027194,7.37643701 C20.2616511,8.91701365 21,10.8722815 21,13 C21,17.9705627 16.9705627,22 12,22 C7.02943725,22 3,17.9705627 3,13 C3,8.02943725 7.02943725,4 12,4 C14.1287073,4 16.0848037,4.7390353 17.6257106,5.97452739 Z M12,20 C15.8659932,20 19,16.8659932 19,13 C19,9.13400675 15.8659932,6 12,6 C8.13400675,6 5,9.13400675 5,13 C5,16.8659932 8.13400675,20 12,20 Z M12,8 C12.5522847,8 13,8.44771525 13,9 L13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,9 C11,8.44771525 11.4477153,8 12,8 Z M10,1 L14,1 C14.5522847,1 15,1.44771525 15,2 C15,2.55228475 14.5522847,3 14,3 L10,3 C9.44771525,3 9,2.55228475 9,2 C9,1.44771525 9.44771525,1 10,1 Z"
      }));
    }
  }]);
  return Other;
}(_react["default"].PureComponent);

var _default = Other;
exports["default"] = _default;